<script>
    import { updateFilterItem, deleteFilterItem } from '@/api/filters.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_FILTER_ITEM_EDIT},
        },
        methods: {
            async save() {
                const data = this.$store.getters.FILTER_ITEM_DATA_EDIT;
                const response = await updateFilterItem(data);
                if (response === true) {
                    const storeData = this.$store.getters.FILTER_ITEM_ID(
                        data['asset_type_id'], data['id']
                    );

                    storeData['name'] = data['name']
                    storeData['parent_ids'] = structuredClone(data['parent_ids']);
                    storeData['is_default'] = data['is_default']
                    await this.close();
                }
            },
            async deleteObj() {
                const data = this.$store.getters.FILTER_ITEM_DATA_EDIT;
                const response = await deleteFilterItem(data.id);
                if (response === true) {
                    this.$store.commit('FILTER_ITEM_SPLICE', {
                        assetID: data.asset_type_id, 
                        filterItemID: data.id,
                    });
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_FILTER_ITEM_EDIT', false);
            },
        }
    }
</script>


<template>
    <button
        :disabled="isSave === false"
        @click="save"
        class="button_blue_100"
    >Save</button>
    <button
        @click="deleteObj"
        class="button_blue_100 button_red ml_10"
    >Delete</button>
    <button
        @click="close"
        class="button_blue_100 close_button mr_10"
    >Close</button>
</template>